import { HubHoverTable } from "@/components/hub/HubHoverTable";

import type { PrePackLaborWorkOrderTableRow } from "./prepackLaborDevHint";
import { formatPrePackLaborDurationMmSs } from "./prepackLaborDevHint";

type HoverRow = PrePackLaborWorkOrderTableRow & { key: string; placeholder: boolean };

export function PrePackLaborStationHoverTable(props: {
  grossElapsedSeconds: number;
  rows: PrePackLaborWorkOrderTableRow[];
}): JSX.Element {
  const { grossElapsedSeconds, rows } = props;
  const emptyCarton = rows.length === 0;
  const displayRows: HoverRow[] = emptyCarton
    ? [
        {
          key: "empty",
          placeholder: true,
          workOrderLabel: "No boxed serials in this carton yet",
          serialCount: 0,
          hypotheticalSeconds: 0,
        },
      ]
    : rows.map((row, index) => ({
        ...row,
        key: `${row.workOrderLabel}-${String(index)}`,
        placeholder: false,
      }));

  return (
    <HubHoverTable
      caption={`Hypothetical allocation of session time ${formatPrePackLaborDurationMmSs(grossElapsedSeconds)} by work order if this were a persisted labor session.`}
      columns={[
        {
          id: "workOrder",
          header: "Work order",
          overflow: "wrap",
          cell: (row) => row.workOrderLabel,
        },
        {
          id: "serialCount",
          header: "Serial count",
          align: "right",
          overflow: "nowrap",
          headerClassName: "w-px",
          cell: (row) => row.serialCount,
        },
        {
          id: "time",
          header: (
            <>
              <span className="block">Time assigned to</span>
              <span className="block font-normal text-slate-500">work order if this were real</span>
            </>
          ),
          align: "right",
          overflow: "nowrap",
          headerClassName: "leading-tight",
          cell: (row) => (row.placeholder ? "—" : formatPrePackLaborDurationMmSs(row.hypotheticalSeconds)),
        },
      ]}
      rows={displayRows}
      rowKey={(row) => row.key}
    />
  );
}
